const listDetailsElem = document.querySelectorAll('.mega-menu.details > summary');
const listContentsElem = document.querySelectorAll('.mega-menu__content');

const listDetails = document.querySelectorAll('details');

listDetails.forEach(item => {
    item.addEventListener('toggle', function() {
        if (!this.open) {
            listContentsElem.forEach(item => {
                item.classList.remove('menu-opening');
                item.parentElement.classList.remove('menu-opening');
            });
            SublistContentsElem.forEach(item => {
                item.classList.remove('menu-opening');
                item.parentElement.classList.remove('menu-opening');
            });
        }
    });
});


listDetailsElem.forEach(item => {
    item.addEventListener('click', function() {
        listContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });

        const content = this.nextElementSibling;
            content.classList.toggle('menu-opening');
        this.parentElement.classList.add('menu-opening');
    });
});


const SublistDetailsElem = document.querySelectorAll('.mega-menu__item.details > summary');
const SublistContentsElem = document.querySelectorAll('.mega-menu__item .mega-menu__content');

SublistDetailsElem.forEach(item => {
    item.addEventListener('click', function() {
        SublistContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });

        const content = this.nextElementSibling;
        content.classList.toggle('menu-opening');
        this.parentElement.classList.add('menu-opening');
    });
});

const myElement = document.querySelector('.main-menu');
document.addEventListener('click', function(event) {
    if (!myElement.contains(event.target)) {
        listContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });
        SublistContentsElem.forEach(item => {
            item.classList.remove('menu-opening');
            item.parentElement.classList.remove('menu-opening');
        });
    }
});
